export interface ProjectTaskSurfaceStatusInput {
  readonly boardLoading: boolean;
  readonly boardError: string | null;
  readonly milestoneGrouped: boolean;
  readonly milestonesLoading: boolean;
  readonly milestonesError: string | null;
}

/** Milestone lanes are only truthful once the milestone catalogue has resolved. */
export function projectTaskSurfaceStatus(input: ProjectTaskSurfaceStatusInput): {
  readonly loading: boolean;
  readonly error: string | null;
} {
  return {
    loading: input.boardLoading || (input.milestoneGrouped && input.milestonesLoading),
    error: input.boardError ?? (input.milestoneGrouped ? input.milestonesError : null),
  };
}
